import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid2,
  Button,
  Link,
  Stack,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import AlertMessage from "../../components/common/AlertMessage";
import ForgotPasswordPageAPI from "../../utils/services/forgotPassword.api";
import ValidateOTPPage from "./validateOTPPage";
import "../../styles/LoginPage.css";
import { ForgotPasswordSchema } from "../../utils/schema/completeProfileSchema";

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [showOtpPage, setShowOtpPage] = useState(false);
  const { generateOTPForgotPassword } = ForgotPasswordPageAPI;
  const formik = useFormik({
    initialValues: {
      username: "",
    },
    validationSchema: ForgotPasswordSchema,
    onSubmit: async (values) => {
      const response = await generateOTPForgotPassword(values.username);
      if (response.status === "success") {
        setOpen(true);
        setMessage("Verification code sent successfully");
        setSeverity("success");
        setTimeout(() => {
          setOpen(false);
          setShowOtpPage(true);
        }, 2000);
      } else if (response.status === "error") {
        setOpen(true);
        setMessage(response.message);
        setSeverity(response.status);
      }
    },
  });
  const handleClose = () => {
    setOpen(false);
  };

  const isNotSpace = (event) => {
    if (!isNaN(event.keyCode) && event.keyCode === 32) {
      event.preventDefault();
    }
  };

  return (
    <Stack className="bg">
      <Grid2>
        <img
          src={require("../../assets/images/login_illustration.png")}
          className="img2"
          alt="img2"
          onDragStart={(e) => {
            e.preventDefault();
          }}
        />
        {!showOtpPage ? (
          <Box
            component="form"
            onSubmit={formik.handleSubmit}
            className="box-element"
          >
            <Box sx={{ display: "grid", width: "100%", padding: "2.5rem" }}>
              <Box sx={{ paddingBottom: "6rem" }}>
                <img
                  src={require("../../assets/logos/a2b-logo.svg").default}
                  alt="a2bLogoImage"
                  style={{ position: "absolute" }}
                  width="82%"
                  height="60px"
                  onDragStart={(e) => {
                    e.preventDefault();
                  }}
                />
              </Box>
              <Typography
                sx={{ fontWeight: "600", color: "#101828" }}
                variant="h5"
              >
                Forgot password?
              </Typography>
              <Typography
                sx={{ marginTop: "1rem", color: "#475467" }}
                variant="body2"
              >
                Don't worry! it happens. Please enter the address that
                associated with your account.
              </Typography>
              <InputLabel
                sx={{ marginTop: "2rem", fontSize: "14px", color: "#344054", fontWeight: "600", zIndex: "2" }}
                htmlFor="outlined-adornment-Email"
              >
                Email ID
              </InputLabel>
              <OutlinedInput
                sx={{ 
                  height:  "38px", 
                  marginTop: "2px",
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#000000",
                  }
                }}
                id="username"
                autoFocus
                placeholder="Enter your Email ID"
                inputProps={{ maxLength: 55 }}
                disabled={severity === "success"}
                autoComplete="off"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={require("../../assets/logos/mail.svg").default}
                      alt="test"
                      width="16px"
                      height="18px"
                      onDragStart={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </InputAdornment>
                }
                value={formik.values.username}
                error={formik.touched.username && formik.errors.username}
                onChange={formik.handleChange}
                onKeyDown={(e) => isNotSpace(e)}
              />
              {formik.touched.username && formik.errors.username && (
                <div style={{ color: "#F04438" }}>{formik.errors.username}</div>
              )}
              <Button
                variant="contained"
                type="submit"
                style={{
                  textTransform: "none",
                  marginTop: "2rem",
                  backgroundColor: "#0C68F4",
                }}
                onClick={formik.handleSubmit}
                disabled={severity === "success"}
              >
                Send verification code
              </Button>
              <Link
                sx={{
                  marginTop: "1rem",
                  maxWidth: "200px",
                  margin: "1rem auto",
                  color: "black",
                  textDecorationColor: "black",
                  fontSize: "14px",
                  cursor: "pointer"
                }}
                underline="always"
                onClick={(e) => {
                  if(severity !== "success") {
                    navigate("/Login");
                  } else {
                    e.preventDefault();
                  }
                }}
                onDragStart={(e) => {
                  e.preventDefault();
                }}
              >
                Back to log in
              </Link>
            </Box>
          </Box>
        ) : (
          <ValidateOTPPage userEmailId={formik.values.username} userMobNo={undefined} showMobilePage={() => {}} />
        )}
      </Grid2>
      <AlertMessage
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </Stack>
  );
}

export default ForgotPasswordPage;
